import selectSettings from './selectSettings';

const selectAppSettings = (state, integration) => selectSettings(state).app;

export default selectAppSettings;
